import styled from 'styled-components';

export const CountryComponent = styled.span<{ fullWidth }>`
  ${({ fullWidth }) => fullWidth && 'width:max-content;'}
  display: inline-flex;
  gap: 0.7em;
  color: ${({ theme }) => theme.colours.charcoalDust};
  font-family: ${({ theme }) => theme.typography.fontFamily.primary};
  font-size: ${({ theme }) => theme.pxToRem(14)};
  letter-spacing: 0;
  line-height: 1.334;
`;

export const CountryFlag = styled.span`
  width: 24px !important;
  height: 18px;
`;
